export function transformFloatOutput(value?: string | null): number | null | undefined {
    const intValue = parseFloat(value as any);
    return isNaN(intValue) ? null : intValue;
}
